import moment from "moment";

export const normalizeNumber = (value, decimalPlaces = 2) => {
  const num = Number(value);
  if (!num) return 0;
  if (!(num % 1)) return num.toString(); // if number is integer, return as is
  const roundedNumber = Math.round((num + Number.EPSILON) * 100) / 100;
  return roundedNumber.toFixed(decimalPlaces);
};

export const convertToLocalTime = (time) => moment.utc(time).local().format("LT");
export const convertToLocalDate = (time) => moment.utc(time).local().format("Do MMM YYYY");
export const convertToLocalDateTime = (time) => moment.utc(time).local().format("Do MMM YYYY, LT");
